<template>
  <p
    v-if="show"
    class="alert alert-danger"
    v-html="text"
  />
</template>

<script>
export default {
  name: 'ShowError',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    text: String,
  },
};
</script>

<style scoped>

</style>
